import { addMinutes } from 'date-fns'

import { VIEWING_FORM_FIELD_NAME } from './RentalPortalViewingFormModal.constants'
import {
  getIsViewingFormBookMode,
  getIsViewingFormSlotSource,
} from './RentalPortalViewingFormModal.utils'

function getViewingFormRepeatUntil({
  [VIEWING_FORM_FIELD_NAME.repeatUntil]: repeatUntil,
  [VIEWING_FORM_FIELD_NAME.withRepeat]: withRepeat,
}) {
  return withRepeat ? repeatUntil : null
}

export function getViewingFormBookPayload(values) {
  const applicantIds = values[VIEWING_FORM_FIELD_NAME.applicant].map(
    item => item.value
  )

  if (getIsViewingFormSlotSource(values)) {
    return {
      applicant_ids: applicantIds,
      slot_id: values[VIEWING_FORM_FIELD_NAME.slot].slot_id,
    }
  }

  return {
    applicant_ids: applicantIds,
    end: getViewingFormEnd(values).toISOString(),
    listing_id: values[VIEWING_FORM_FIELD_NAME.listing].value,
    start: values[VIEWING_FORM_FIELD_NAME.start].toISOString(),
  }
}

export function getViewingFormPayload(values) {
  const repeatUntil = getViewingFormRepeatUntil(values)

  return {
    duration_min: values[VIEWING_FORM_FIELD_NAME.duration].value,
    listing_id: values[VIEWING_FORM_FIELD_NAME.listing].value,
    ...(repeatUntil ? { repeat_until: repeatUntil.toISOString() } : null),
    start: values[VIEWING_FORM_FIELD_NAME.start].toISOString(),
  }
}

export function getViewingFormModalPayload(values) {
  return getIsViewingFormBookMode(values)
    ? getViewingFormBookPayload(values)
    : getViewingFormPayload(values)
}

export function getViewingFormEnd(values) {
  const start = values[VIEWING_FORM_FIELD_NAME.start]

  return start
    ? addMinutes(start, values[VIEWING_FORM_FIELD_NAME.duration]?.value ?? 0)
    : null
}
